<div class="text-center component-container">
  <fieldset class="button-bar" [disabled]="(status$ | async) !== 'loaded'">
    <h3-button (h3Click)="changeZoom(11 / 10)" matTooltip="Zoom In">
      <fa-icon [icon]="faSearchPlus"></fa-icon>
    </h3-button>
    <h3-button (h3Click)="changeZoom(10 / 11)" matTooltip="Zoom Out">
      <fa-icon [icon]="faSearchMinus"></fa-icon>
    </h3-button>
    <h3-button (h3Click)="reset()" matTooltip="Zoom to Fit">
      <fa-icon [icon]="faExpandArrowsAlt"></fa-icon>
    </h3-button>
    <h3-button
      (h3Click)="changeZoom(1 / zoom$.value)"
      matTooltip="Zoom to Actual Size"
    >
      <fa-icon [icon]="faImage"></fa-icon>
    </h3-button>
    <mat-button-toggle-group *ngIf="gridSize">
      <mat-button-toggle
        [checked]="showGrid"
        (click)="showGrid = !showGrid"
        matTooltip="Show Grid"
      >
        <fa-icon [icon]="faTh"></fa-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </fieldset>

  <ng-container [ngSwitch]="status$ | async">
    <div *ngSwitchCase="'no url'">No image provided</div>
    <div *ngSwitchCase="'loading'">
      <div class="loading-image"></div>
      Loading...
    </div>
    <div *ngSwitchCase="'error'">Error loading image</div>
  </ng-container>

  <div class="image-container" *ngIf="(status$ | async) === 'loaded'">
    <div
      (mousedown)="startPanning($event)"
      [style.transform]="transform$ | async"
      style.display="inline-block"
    >
      <img [src]="url" />
      <div
        *ngIf="showGrid"
        class="grid overlay"
        [style.grid-template-columns]="gridTemplateColumns"
      >
        <ng-container *ngFor="let row of gridRows">
          <ng-container *ngFor="let col of gridColumns">
            <div class="grid-box" [style.border-color]="gridColor"></div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
